<template>
  <w-modal
    v-model="show"
    :title="$t('titles.set-password')"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    :show-footer="false"
    @close="close()"
  >
    <password-form :current-password="true" @setPassword="setPassword" />
  </w-modal>
</template>

<script>
import WModal from '@witkac/bootstrap4-components/src/components/modal.vue';

import { minimalModalNoSchemaMixin } from '@/mixins/minimalModalNoSchema';
import PasswordForm from '@/components/forms/PasswordForm';

// @vuese
// Modal zmiany hasła użytkownika
// @group Modals
export default {
  components: { PasswordForm, WModal },
  mixins: [minimalModalNoSchemaMixin],
  methods: {
    // @vuese
    // Zmiana hasła zalogowanego użytkownika
    setPassword({ password, currentPassword }) {
      this.$store
        .dispatch('auth/setPassword', { password, currentPassword })
        .then(() => {
          this.notifySuccess('messages.auth.passwordSet');
          this.close();
        })
        .catch(err => this.notifyError('messages.auth.setPasswordError'));
    }
  }
};
</script>
